import ls from 'local-storage'

// Funzione che si occupa di creare l'header di autorizzazione e popolarlo con il token presente nel localStorage
export default function createHeaders (params = null, overrideAuthToken = null, skipAuth = false) {
  const token = ls.get('plsadv_token')

  const headers = {
    headers: {}
  }

  // skipAuth: endpoint pubblici (es. /demo/mc) — un token scaduto causerebbe 401
  if (!skipAuth && (overrideAuthToken || token)) {
    headers.headers.authorization = overrideAuthToken || token
  }

  if (params) {
    headers.params = params
  }

  return headers
}
